










































































import DossierLabels from "./../DossierLabels.js";
import Vue, { PropType } from "vue";
import { Personeelslid } from "../../../types/dossier/data/Personeelslid.js";

export default Vue.extend({
  name: "personeelslid-view",
  props: {
    personeelslid: {
      type: Object as PropType<Personeelslid>,
      required: true,
    },
    hiddenFieldsMap: {
      type: Object,
    },
  },
  data() {
    return {
      labels: DossierLabels.personeelslid,
    };
  },
  methods: {
    formatInsz(insz): string {
      if (insz.length == 11) {
        return (
          insz.substring(0, 2) +
          "." +
          insz.substring(2, 4) +
          "." +
          insz.substring(4, 6) +
          "-" +
          insz.substring(6, 9) +
          "." +
          insz.substring(9, 11)
        );
      } else {
        return insz;
      }
    },
  },
});
